/**
 * Cart drawer bundle upsell
 *
 * The drawer's static discount banner becomes a PDP-style trigger + inline
 * builder (see get-extra-discount.liquid): the paired bundle product is
 * pre-suggested, the metaobject collection provides alternatives, and the
 * chosen size is added straight to the cart.
 *
 * All handlers are delegated on document because the cart drawer's DOM is
 * replaced by section rendering on every cart update.
 */
(function () {
  if (window.__cartBundleUpsellInit) return;
  window.__cartBundleUpsellInit = true;

  const formatMoney = (cents) => (cents / 100).toFixed(2).replace('.', ',') + '€';

  const builderFor = (el) => el.closest('[data-cart-bundle]') || document.querySelector('[data-cart-bundle]');

  const selectedSizeBtn = (builder) =>
    builder.querySelector('[data-candidate]:not([hidden]) .bundle-builder__size-btn.is-selected');

  const updateAtc = (builder) => {
    const atc = builder.querySelector('[data-cart-bundle-atc]');
    const totalEl = builder.querySelector('[data-cart-atc-total]');
    const sel = selectedSizeBtn(builder);
    if (atc) atc.disabled = !sel;
    if (totalEl) totalEl.textContent = sel ? ' · ' + formatMoney(parseInt(sel.dataset.variantPrice, 10)) : '';
  };

  const selectPickerItem = (builder, pick) => {
    const targetId = pick.dataset.pickerTarget;
    builder.querySelectorAll('.bundle-builder__picker-item.is-selected').forEach((b) => b.classList.remove('is-selected'));
    pick.classList.add('is-selected');
    pick.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    builder.querySelectorAll('[data-candidate]').forEach((g) => {
      const active = g.dataset.builderProductId === targetId;
      g.hidden = !active;
      if (!active) {
        g.querySelectorAll('.bundle-builder__size-btn.is-selected').forEach((b) => b.classList.remove('is-selected'));
      }
    });
    updateAtc(builder);
  };

  document.addEventListener('click', async (e) => {
    // 1) Trigger: toggle the builder; pre-select the first (paired) product.
    const trigger = e.target.closest('.cart-bundle-trigger');
    if (trigger) {
      const builder = builderFor(trigger);
      if (!builder) return;
      builder.classList.toggle('bundle-promotion--hidden');
      if (!builder.classList.contains('bundle-promotion--hidden')) {
        if (!builder.querySelector('.bundle-builder__picker-item.is-selected')) {
          const first = builder.querySelector('.bundle-builder__picker-item');
          if (first) selectPickerItem(builder, first);
        }
        builder.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
      return;
    }

    const builder = e.target.closest('[data-cart-bundle]');
    if (!builder) return;

    // 2) Picker: switch the visible candidate.
    const pick = e.target.closest('.bundle-builder__picker-item');
    if (pick) {
      selectPickerItem(builder, pick);
      return;
    }

    // 3) Size selection + delivery note.
    const sizeBtn = e.target.closest('.bundle-builder__size-btn');
    if (sizeBtn && !sizeBtn.disabled) {
      const group = sizeBtn.closest('.bundle-builder__product');
      group.querySelectorAll('.bundle-builder__size-btn.is-selected').forEach((b) => b.classList.remove('is-selected'));
      sizeBtn.classList.add('is-selected');
      const note = group.querySelector('[data-delivery-note]');
      const text = group.querySelector('[data-delivery-text]');
      if (note && text) {
        const inStock = sizeBtn.dataset.inStock === 'true';
        note.classList.remove('bundle-promotion--hidden');
        note.classList.toggle('is-preorder', !inStock);
        const full = inStock ? (group.dataset.instockText || '') : (group.dataset.preorderText || '');
        const idx = inStock ? -1 : full.indexOf(':');
        text.textContent = '';
        if (idx === -1) {
          text.textContent = full;
        } else {
          const link = document.createElement('a');
          link.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'pages/pre-order';
          link.className = 'bundle-builder__preorder-link';
          link.textContent = full.slice(0, idx);
          text.appendChild(link);
          text.appendChild(document.createTextNode(full.slice(idx)));
        }
      }
      updateAtc(builder);
      return;
    }

    // 4) Add the chosen variant; the drawer re-renders via cart events.
    const atc = e.target.closest('[data-cart-bundle-atc]');
    if (atc && !atc.disabled) {
      const sel = selectedSizeBtn(builder);
      if (!sel) return;
      atc.disabled = true;
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(sel.dataset.variantId, 10), quantity: 1 }] })
        });
        if (!res.ok) throw new Error('cart bundle add failed: ' + res.status);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:item-added'));
      } catch (err) {
        console.error('Cart bundle upsell: add failed', err);
        atc.disabled = false;
      }
    }
  });
})();
